import { render, staticRenderFns } from "./KeyBindingsSettings.vue?vue&type=template&id=3196a075&"
import script from "./KeyBindingsSettings.vue?vue&type=script&lang=js&"
export * from "./KeyBindingsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports